export const SharedModalsMap = {
  LOADER_MODAL: 'loaderModal',
  EMPTY_MODAL: 'emptyModal',
  INFO_MODAL: 'infoModal',
  AVAILABLE_EXTENSIONS_MODAL: 'availableExtensionsModal',
  SITE_SELECTOR_MODAL: 'siteSelectorModal',
  TLDS_SHEET: 'tldsSheet'
};
//# sourceMappingURL=sharedModals.js.map